import { Box, Typography } from '@mui/material';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../hooks/useStore';
import { DataGrid, DataGridElement } from '../../../lib/components/compound/dataGrid';
import Util from '../../../misc/util';
import { useNavigate, useParams } from 'react-router';
import { EmployeeSummaryTable } from '../../../lib/components/tables/employee/employeeSummary';
import {
  CreatePayrollExportRequest,
  CreateReceiptExportRequest
} from '@pxtra-client-lib-legacy/gen';
import { useEffect } from 'react';

export const ExportSummary = () => {
  const { t } = useTranslation();
  const { exportFlowStore } = useStore();
  const { type } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!exportFlowStore.hasSelectedEmployees() && type !== 'voucher_orders') {
      navigate(`/exports/${type}/1`);
      return;
    }

    if (!exportFlowStore.hasSelectedFormat()) {
      if (type === 'voucher_orders') {
        navigate(`/exports/voucher_orders/1`);
      } else {
        navigate(`/exports/${type}/2`);
      }
    }
  }, [exportFlowStore, type, navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}
    >
      <DataGrid>
        <DataGridElement
          xs={type !== 'employee_data' ? 4 : 6}
          title={t('export:SUMMARY_FIELD_TITLE_TYPE')}
          value={t('tasks:TYPE', { context: type })}
        />
        {type !== 'employee_data' ? (
          <DataGridElement
            xs={4}
            title={t('common:PERIOD')}
            value={`${
              (exportFlowStore.data as CreatePayrollExportRequest | CreateReceiptExportRequest)
                ?.accounting_period_from &&
              format(
                Util.getDate(
                  (exportFlowStore.data as CreatePayrollExportRequest | CreateReceiptExportRequest)
                    ?.accounting_period_from
                ),
                'MMMM yyyy',
                { locale: Util.getLocale() }
              )
            }`}
          />
        ) : null}
        <DataGridElement
          xs={type !== 'employee_data' ? 4 : 6}
          title={t('export:SUMMARY_FIELD_TITLE_FORMAT')}
          value={t(`export:FILE_TYPE_${exportFlowStore.data?.format}`)}
        />
      </DataGrid>
      <Typography variant="h3" paddingTop={3}>
        {type !== 'voucher_orders'
          ? t('employee:SELECTED_COUNT', {
              count:
                (exportFlowStore.data as { employees_query?: { ids?: string[] } }).employees_query
                  ?.ids?.length ?? 0
            })
          : ''}
      </Typography>
      {type !== 'voucher_orders' && <EmployeeSummaryTable />}
    </Box>
  );
};
